import { type Access, useAccess } from "@/shared/api/grants";

export type OrderRole = "backOffice" | "advisor";

export function useOrderRole(): OrderRole | null {
  return orderRoleOf(useAccess());
}

export function orderRoleOf(access: Access | null): OrderRole | null {
  if (access === null) return null;
  return access.superuser ? "backOffice" : "advisor";
}
